import dataView from "./dataView.js";
import svg from "./svg.js";
import dataAnalysis from "./dataAnalysis.js";
import prefixSuffixRuleSetting from "./prefixSuffixRuleSetting.js";
import { eventTemp } from "_dataview/output/utils/relativeEvent";
export default {
  mixins: [dataView, svg, dataAnalysis, prefixSuffixRuleSetting],
  props: {
    //风格对应组件key
    styleMapKey: {
      type: String,
      default: "dataviewTable",
    },
    //事件依赖
    eventRelativeDeal: {
      type: Object,
      default() {
        return {
          load: {
            relatives: [],
            fn: eventTemp,
          },
          click: {
            relatives: [],
            fn: eventTemp,
          },
          clickCell: {
            relatives: [],
            fn: eventTemp,
          },
        };
      },
    },
    prop_header_font_family: {
      type: String,
      default: "Microsoft Yahei",
    },
    fontFamily: {
      type: String,
      default: "Microsoft Yahei",
    },
    isHighlightCurrentRow: {
      type: Boolean,
      default: false,
    },
    highlightBgColor: {
      type: String,
      default: "rgba(245, 247, 250, 0.2)",
    },
    isShowWarnLine: {
      type: Boolean,
      default: false,
    },
    contentColor: {
      type: String,
      default: "#fff",
    },
    prop_headerBGC: {
      type: String,
      default: "rgba(255, 255, 255, 0)",
    },
    prop_headerColor: {
      type: String,
      default: "#DCF0FF",
    },
    isShowHeaderBorder: {
      type: Boolean,
      default: true,
    },
    isShowHeaderBorderBottom: {
      type: Boolean,
      default: true,
    },
    headerBorderBottomWidth: {
      type: String,
      default: "1",
    },
    isHeaderBorderBottomSolid: {
      type: Boolean,
      default: true,
    },
    headerBorderBottomColor: {
      type: String,
      default: "#888",
    },
    prop_oddRowBGC: {
      type: String,
      default: "rgba(255, 255, 255, 0)",
    },
    prop_evenRowBGC: {
      type: String,
      default: "rgba(255, 255, 255, 0)",
    },
    isShowContentBorder: {
      type: Boolean,
      default: true,
    },
    isShowContentBorderBottom: {
      type: Boolean,
      default: true,
    },
    contentBorderBottomWidth: {
      type: String,
      default: "1",
    },
    isContentBorderBottomSolid: {
      type: Boolean,
      default: true,
    },
    contentBorderBottomColor: {
      type: String,
      default: "#888",
    },
    isShowHeader: {
      type: Boolean,
      default: true,
    },
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            controls: [],
          },
        ];
      },
    },
    rowBgColorRules: {
      type: Object,
      default: () => ({
        defaultForm: {
          backgroundColor: "rgba(255,255,255,0)",
        },
        ruleList: [
          {
            rule: "@[index%2] === 0",
            backgroundColor: "",
          },
          {
            rule: "@[index%2] === 1",
            backgroundColor: "",
          },
        ],
      }),
    },
  },
  watch: {
    headData: {
      handler(val) {
        if (this.isDesign) {
          setTimeout(() => {
            this.dataAnalysis(this.originData);
          }, 0);
        }
      },
      deep: true,
    },
    config: {
      handler() {
        if (this.isDesign) {
          setTimeout(() => {
            this.dataAnalysis(this.originData);
          }, 0);
        }
      },
      deep: true,
    },
    staticData: {
      handler() {
        if (this.isDesign) {
          setTimeout(() => {
            this.dataAnalysis(this.originData);
          }, 0);
        }
      },
    },
    isShowHeader() {
      if (this.isDesign) {
        setTimeout(() => {
          this.dataAnalysis(this.originData);
        }, 0);
      }
    },
  },
  computed: {
    headerBGC() {
      let color = this.prop_headerBGC;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    headerColor() {
      let color = this.prop_headerColor;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    oddRowBGC() {
      let color = this.prop_oddRowBGC;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    evenRowBGC() {
      let color = this.prop_evenRowBGC;
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    getHeaderWrapItem() {
      let height = this.config.headerHeight * this.headLevel;
      let obj = {
        height: this.isShowHeaderBorder ? `${height - 1}px` : `${height}px`,
        color: this.headerColor,
        "font-size": this.propHeaderFontSize,
        fontFamily: this.prop_header_font_family,
      };
      let headerBorderBottomColor = this.getColor(this.headerBorderBottomColor);
      let headerBorder = this.getBorderCss(
        this.headerBorderBottomWidth,
        this.isHeaderBorderBottomSolid,
        headerBorderBottomColor
      );
      if (this.isShowHeaderBorderBottom) {
        obj["border-bottom"] = headerBorder;
      }
      return obj;
    },
  },
  data() {
    return {
      tableSlot: [],
      headLevel: 1,
      activeRowId: null,
      outerAutoCalcMaxObj: {}, // 用于存储当bar没有百分比字段的时候
      barAutoCalcMaxObj: {}, // 用于存储柱状自动计算的最大值,
    };
  },
  mounted() {
    // 兼容之前设置的奇偶的背景行的颜色
    this.compatibleRowColor();
  },
  methods: {
    handleRowBackGroundColor(row, index) {
      let ruleList = this.rowBgColorRules.ruleList;
      let backgroundColor = "";
      for (let i = 0; i < ruleList.length; i++) {
        let ruleObj = ruleList[i];
        try {
          let flag = this.$eval(ruleObj.rule, {
            ...row,
            index,
          });
          if (flag) {
            backgroundColor = ruleObj.backgroundColor;
            break;
          }
        } catch (error) {
          console.log("handlePrefixSuffixRule", error);
        }
      }
      return backgroundColor;
    },
    compatibleRowColor() {
      let cloneObj = _.cloneDeep(this.rowBgColorRules);
      let originData = [
        {
          rule: "@[index%2] === 0",
          backgroundColor: "",
        },
        {
          rule: "@[index%2] === 1",
          backgroundColor: "",
        },
      ];
      let ruleList = cloneObj.ruleList;
      let flag = _.isEqual(originData, ruleList);
      if (flag) {
        if (ruleList[0]) {
          ruleList[0].backgroundColor = this.prop_evenRowBGC;
        }
        if (ruleList[1]) {
          ruleList[1].backgroundColor = this.prop_oddRowBGC;
        }
        this.$emit("update:rowBgColorRules", cloneObj);
      }
    },
    allTableWrapStyle() {
      let {
        isShowBorder,
        borderBottomWidth,
        isBorderBottomSolid,
        borderBottomColor,
      } = this;
      let controlStyle = this.controlStyle;
      let style = {
        ...controlStyle,
      };
      if (isShowBorder) {
        style.border = this.getBorderCss(
          borderBottomWidth,
          isBorderBottomSolid,
          borderBottomColor
        );
      }
      return style;
    },
    allTableStyle() {
      let { backgroundColor } = this;
      let style = {
        "background-color": backgroundColor,
      };
      return style;
    },
    getPrefixStyle(row, header) {
      let style =
        this.handlePrefixSuffixStyle(header.prefixRuleConfig, row, {
          defaultRuleShowType: header.prefixShowType,
          defaultRuleIcon: header.prefixIcon,
          defaultRuleContent: header.prefixContent,
          defaultRuleImg: header.prefixRuleConfig.defaultForm.imgObj,
        }) || {};
      return style;
    },
    getSuffixStyle(row, header) {
      let style =
        this.handlePrefixSuffixStyle(header.suffixRuleConfig, row, {
          defaultRuleShowType: header.suffixShowType,
          defaultRuleIcon: header.suffixIcon,
          defaultRuleContent: header.suffixContent,
          defaultRuleImg: header.suffixRuleConfig.defaultForm.imgObj,
        }) || {};
      return style;
    },
    getDataRuleStyle(row, header) {
      let style =
        this.handlePrefixSuffixStyle(header.dataRuleConfig, row) || {};
      return style;
    },
    getHeaderNameStyle(it) {
      let padding = this.handleArrPX(it.commonPadding);
      return {
        padding,
      };
    },
    getHeaderItem(it, i) {
      let height = `${this.config.headerHeight}px`;
      let fontSize = this.transPX(it.headerFontSize);
      let headerColor = it.headerColor;
      let fontFamily = it.headerFontFamily;

      let border = this.getBorderCss(
        this.headerBorderBottomWidth,
        this.isHeaderBorderBottomSolid,
        this.headerBorderBottomColor
      );
      let style = {
        height:
          this.config.headerHeight * (this.headLevel - it.level + 1) + "px",
        fontSize,
        color: headerColor,
        lineHeight: height,
        textAlign: it.headerAlign,
        fontFamily,
      };
      // 最外层级高度统一
      if (!it.children || it.children.length === 0) {
        style.lineHeight =
          this.config.headerHeight * (this.headLevel - it.level + 1) + "px";
      }

      if (!it.children || it.children.length === 0) {
        let index = this.header.findIndex((cItem) => {
          return cItem.id === it.id;
        });
        let width = Number(this.widths[index]);
        style.width = width + "px";
        if (it.isSort) {
          style["padding-right"] = "16px";
        }
      } else if (it.children && it.children.length > 0) {
        style.width = this.getFatherNodeWidth(it.children) + "px";
      }
      if (this.isShowHeaderBorder) {
        if (it.isFirst) {
          style["border-left"] = border;
        }
        style["border-top"] = border;
        if (it.hasRight || it.isLast) {
          style["border-right"] = border;
        }
      }
      if (!this.isDesign) {
        style["flex-shrink"] = 0;
      }
      return style;
    },
    getFatherNodeWidth(it) {
      let width = 0;
      it.forEach((item) => {
        if (item.children && item.children.length > 0) {
          width += Number(this.getFatherNodeWidth(item.children));
        } else {
          let index = this.header.findIndex((cItem) => {
            return cItem.id === item.id;
          });
          if (index !== -1) width += Number(this.widths[index]);
        }
      });
      return width;
    },
    getSortWHF(row) {
      let attrObj = this.indexAttrConfig;
      let isRound = attrObj.isRound;
      let borderRadius = this.transPX(attrObj.borderRadius);
      let width = this.transPX(attrObj.width);
      let height = this.transPX(attrObj.height);
      let fontWeight = attrObj.fontWeight;
      let bgColor = this.getColorIcon(attrObj, "bgColors", row.rowIndex);
      let fontColor = this.getColorIcon(attrObj, "fontColors", row.rowIndex);
      let obj = {
        width,
        height,
        backgroundColor: bgColor,
        fontWeight: fontWeight,
        color: fontColor,
      };
      if (isRound) {
        obj["border-radius"] = "50%";
      } else {
        obj["border-radius"] = borderRadius;
      }
      let icon = this.getColorIcon(attrObj, "icons", row.rowIndex);
      obj.other = {
        ...attrObj,
        icon,
      };
      return obj;
    },
    getColorIcon(attrObj, field, index) {
      let arr = attrObj[field];
      let arrLength = arr.length - 1;
      let str = arr[index] || "";
      if (index > arrLength) {
        str = arr[arrLength] || "";
      }
      return str;
    },
    //解析表格数据
    dataExcelAnalysis(res) {
      let data = dsf.dataview.utils.dataExcelCommonExcelToArrayObj(
        res,
        (fieldArray) => {
          this.$emit("update:excelMapFieldList", fieldArray);
        }
      );

      this.$dataAnalysis(data);
    },
    //分析数据
    dataAnalysis(data, flag) {
      if (!data || !data.length) {
        this.hasData = false;
        return;
      }
      this.hasData = true;

      this.data = this.handleServiceData(data);
      this.originData = _.cloneDeep(this.data);

      this.handleHeaderSlot();
      this.calcHeaderData();
      this.calcRowsDataData();
      this.$nextTick(() => {
        this.onResize();
      });
    },
    calcRowsDataData() { },
    extraSpecialRender(data = this.data) {
      data.forEach((item, index) => {
        if (!item.id) {
          item.id = dsf.uuid(16);
          item.index = index + 1;
          item.rowIndex = index;
        }
      });
    },
    handleHeaderSlot() {
      // 创建一个新的数组用于存放符合条件的对象
      const result = [];
      // 递归遍历数组
      function traverse(arr) {
        for (let i = 0; i < arr.length; i++) {
          const obj = arr[i];
          const children = obj.children || [];
          // 当children为空或不存在，并且headerSlotName匹配时将对象放入结果数组中
          if (children.length === 0 && obj.headerSlotName) {
            result.push(obj);
          }
          // 递归遍历children数组
          if (children.length) {
            traverse(children);
          }
        }
      }
      // 开始递归遍历
      traverse(this.headData);
      this.tableSlot = result;
    },
    //映射处理接口返回数据
    handleServiceData(data) {
      this.barAutoCalcMaxObj = {};
      this.outerAutoCalcMaxObj = {};
      if (!Array.isArray(data)) return [];
      let maxObj = {};
      let outerMaxObj = {};
      let flatData = this.flatten(this.headData);
      data.forEach((item, index) => {
        if (item.id === undefined) {
          item.id = dsf.uuid(16);
        }
        item.index = index + 1;
        item.rowIndex = index;
        flatData.forEach((h) => {
          if (h.isBar) {
            this.getCalcMaxBar(outerMaxObj, maxObj, item, h);
          }
        });
      });
      this.barAutoCalcMaxObj = maxObj;
      this.outerAutoCalcMaxObj = outerMaxObj;
      return data;
    },
    getCalcMaxBar(outerMaxObj, maxObj, it, header) {
      let id = header.id;
      let barArr = header.barInfo;
      for (let i = 0; i < barArr.length; i++) {
        let oneBar = barArr[i];
        let itVal = Number(it[oneBar.field]);
        let val = isNaN(itVal) ? 0 : itVal;
        if (!maxObj[id]) {
          maxObj[id] = new Array(barArr.length).fill(0);
          outerMaxObj[id] = new Array(barArr.length).fill(0);
        }
        let max = maxObj[id][i];
        let outerMax = outerMaxObj[id][i];
        if (val > max) {
          maxObj[id][i] = val;
        }
        if (it.name > outerMax) {
          outerMaxObj[id][i] = it.name;
        }
      }
    },
    //计算平均高度
    dealAvgHeight() {
      const { realHeight: height, config, header, isShowHeader } = this;
      const { headerHeight, rowNum, slotHeight = 0 } = config;
      let allHeight = height;
      if (header.length && isShowHeader && header.length)
        allHeight -= headerHeight * this.headLevel;
      allHeight -= slotHeight;
      let avg = allHeight / rowNum;
      return avg;
    },
    // 停止滚动(轮播表格)
    stopAnimation() { },
    //开启轮播(轮播表格)
    animation() { },
    //计算宽高
    calWH() {
      this.calcWidths();
      this.calcHeights();
    },
    //计算表头数据
    calcHeaderData() {
      this.header = _.cloneDeep(this.headData);
      let { index, indexHeader, indexWidth } = this.config;
      let { header } = this;
      if (index) {
        header.unshift({
          label: indexHeader,
          isIndex: true,
          headerAlign: "center",
          align: "center",
          width: indexWidth,
        });
      }
      this.transformTree(header, 1);
      let flatData = this.flatten(header);
      if (this.orgHeader) this.orgHeader = header;
      this.header = flatData;
    },
    //处理表格头部数据
    transformTree(tree, n, hasRight = false) {
      this.headLevel = Math.max(this.headLevel, n);
      tree.forEach((it, index) => {
        const item = it;
        let $hasRight = hasRight;
        if (!$hasRight && index < tree.length - 1) {
          $hasRight = true;
        } else if ($hasRight && index == tree.length - 1) {
          $hasRight = false;
        }
        //第一个
        if (index == 0 && n === 1) {
          it.isFirst = true;
        }
        //最后一个
        if (index == tree.length - 1 && n === 1) {
          it.isLast = true;
        }
        item.level = n;
        item.hasRight = $hasRight;

        if (it.children) {
          this.transformTree(it.children, n + 1, $hasRight);
        } else {
          item.hide = false;
        }
      });
    },
    //计算列宽
    calcWidths() {
      const { realWidth: width, header } = this;
      const flatData = this.flatten(header);
      let widths = flatData.map((it) => {
        if (typeof it.width == "number" || /\d+$/g.test(it.width)) {
          return it.width;
        } else if (/%$/g.test(it.width)) {
          return (width * parseFloat(it.width)) / 100;
        }
        return "";
      });
      let columnNum = widths.filter((it) => it).length;

      const usedWidth = widths.reduce((all, w) => all + Number(w), 0);

      const avgWidth = (width - usedWidth) / (widths.length - columnNum);

      widths = widths.map((it) => (it ? it : avgWidth));
      if (this.isDesign) {
        let lastNum = widths[widths.length - 1];
        widths[widths.length - 1] = dsf.isNumber(lastNum)
          ? lastNum - 1
          : lastNum;
      }
      this.widths = widths;
    },
    flatten(arr) {
      return arr.reduce((acc, val) => {
        if (val.children && val.children.length > 0) {
          acc = acc.concat(this.flatten(val.children));
        } else {
          acc.push(val);
        }
        return acc;
      }, []);
    },
    getGeneralVal(row, header) {
      let val = row[header.map] || "";
      val = this.handleMapRelationNum(val, header);
      if (header.unitTransform) {
        return this.transformUnit(val, header.unitTransform, true, 2);
      }
      if (header.isThousandths === undefined || header.isThousandths) {
        return dsf.dataview.utils.toThSeparator(val);
      }
      return val;
    },
    //事件发送
    emitEvent(type, ri, ci, row, ceil) {
      const { rowIndex } = row;
      this.activeRowId = row.id;
      this.$dispatch(type, {
        row,
        ceil,
        rowIndex,
        columnIndex: ci,
      });
      if (type === "clickItem") {
        let value = row[ceil.map] || "";
        let label = ceil?.label || "";
        this.loadClickEvents(row);
        let nowObjCell = {
          value,
          label,
        };
        this.$dispatch("loadClickCellEvents", nowObjCell);
        this.loadClickCellEvents(nowObjCell);
      }
    },
    progressWrapStyle(header) {
      let style = {
        width: this.barWidth,
        "margin-bottom": this.transPX(header.barSpace),
      };
      return style;
    },
    //计算bar样式
    getOuterStyle(index, barIndex) {
      let header = this.header[index];
      let isArray = Array.isArray(header.barInfo);
      let barInfo = isArray ? header.barInfo[barIndex] : header.barInfo;
      let colors = barInfo.baseBgColors;
      let color = isArray ? colors[0] : colors[index % colors.length];
      let borderRadius = barInfo.borderRadius;

      let background = color;
      return {
        height: this.transPX(barInfo.height),
        borderRadius: this.transPX(borderRadius),
        background,
      };
    },
    //计算bar条样式
    getInnerStyle(row, ceil, index, barIndex) {
      let header = ceil;
      let isArray = Array.isArray(header.barInfo);
      let barInfo = isArray ? header.barInfo[barIndex] : header.barInfo;
      let percent = this.getBarInterValue(barInfo, row, barIndex, header);
      let colors = barInfo.bgColors;
      let color = isArray ? colors[0] : colors[index % colors.length];
      let background = color;
      let barRuleObj = barInfo.bgColorRule;
      if (barRuleObj) {
        let barColorStyle = this.handlePrefixSuffixRule(barRuleObj, row, {});
        background = barColorStyle.color ? barColorStyle.color : color;
      }
      if (barInfo.isGradient) {
        background = `linear-gradient(90deg,${colors[0]},${colors[1]})`;
      }
      return {
        width: `${percent}%`,
        background,
      };
    },
    // 获取bar背景颜色的值
    getBarInterValue(barObj, row, barIndex, header) {
      let percent = row[header.map] || 0;
      let staticValue = barObj.staticValue * 1;
      let field = barObj.field;
      let percentField = barObj.percentField;
      if (this.dataType === "static") {
        if (
          barObj.staticValue !== "" &&
          barObj.staticValue !== undefined &&
          !isNaN(staticValue)
        ) {
          percent = staticValue;
        }
      } else {
        let minBarPercent = barObj.minBarPercent;
        if (barObj.isAutoCalc) {
          if (field) {
            let max = this.barAutoCalcMaxObj[header.id][barIndex];
            let val = row[field] * 1;
            percent = this.getAutoCalcPercent(max, val, minBarPercent);
          } else {
            // // 就用外层
            // let max = this.outerAutoCalcMaxObj[[header.id][barIndex];
            // let val = row.name * 1;
            // percent = this.getAutoCalcPercent(max, val, minBarPercent);
          }
        } else {
          // 没有开启自动计算
          if (percentField) {
            if (dsf.isNumber(minBarPercent)) {
              percent =
                row[percentField] < minBarPercent
                  ? minBarPercent
                  : row[percentField];
            } else {
              percent = row[percentField];
            }
          } else if (field) {
            // percent = row[field];
          }
        }
      }
      if (percent > 100) {
        percent = 100;
      }
      return percent;
    },
    getAutoCalcPercent(max, val, minP) {
      let percent = 0;
      if (max && max !== 0 && !isNaN(val)) {
        let nowPercent = _.round((val / max) * 100, 2);
        if (dsf.isNumber(minP)) {
          percent = nowPercent > minP ? nowPercent : minP;
        } else {
          percent = nowPercent;
        }
      } else {
        percent = 0;
      }
      return percent;
    },
    //获取bar 显示值
    getBarValue(barObj, ceil, row) {
      if (!barObj.showValue) {
        return "";
      }
      let percent = row[ceil.map];
      let staticValue =
        dsf.dataview.utils.toThSeparator(barObj.staticValue) || "";
      let val = `${staticValue ? staticValue : percent}${barObj.fieldSuffix}`;
      if (this.dataType === "static") {
        return val;
      } else {
        let unit = row[barObj.fieldSuffix]
          ? row[barObj.fieldSuffix]
          : barObj.fieldSuffix;
        if (barObj.field) {
          return `${dsf.dataview.utils.toThSeparator(
            row[barObj.field]
          )}${unit}`;
        }
        return unit;
      }
    },
    //获取bar 后缀样式
    getBarSuffixStyle(barObj, row) {
      let style = {};
      if (barObj.isSuffixFlag) {
        style = this.handlePrefixSuffixStyle(barObj.suffix, row) || {};
      }
      return style;
    },
    //判断是否是icon
    judgeIsIcon(headerObj) {
      let obj = headerObj.prefixObj;
      if (obj) {
        return true;
      }
      return false;
    },
    onResize(isReset) {
      this.stopAnimation();
      this.calWH();
      if (isReset) {
        this.animationIndex = 0;
        this.animationHandler = "";
        this.updater = 0;
      }
      const { animation } = this;
      animation(true);
      // 只支持一列bar
      this.$nextTick(() => {
        let tb = this.$refs[this.ref];
        let processTextDom = $(tb).find(".progress-text");
        let widths = [];
        for (let i = 0; i < processTextDom.length; i++) {
          let dom = processTextDom[i];
          widths.push($(dom).width());
        }
        let max = Math.ceil(Math.max(...widths)) + 10;
        this.barWidth = `calc(100% - ${max}px)`;
      });
    },
    handleRowItemMouseEnter(e) {
      if (this.isHighlightCurrentRow) {
        $(e.target).css("background-color", this.highlightBgColor);
      }
    },
    handleRowMouseLeave(e, row, ri) {
      if (this.isHighlightCurrentRow) {
        let style = this.getRowItemStyle(row, ri);
        $(e.target).css("background-color", style["background-color"]);
      }
    },
    dataSortEvent(sort, field) {
      return this;
    },
    styleChangeHeaderAttr(arr, attrObj) {
      arr.forEach((item) => {
        // 只改变最后一层
        if (!item.children || item.children.length === 0) {
          if (item.isBar) {
            item.barInfo.forEach((bar) => {
              bar.bgColors = [...attrObj.barColors];
            });
          }
        }
        item.hide = false;
        if (item.children && item.children.length > 0) {
          this.styleChangeHeaderAttr(item.children, attrObj);
        }
      });
    },
    styleConfigCallback(styleObj) {
      if (styleObj) {
        Object.keys(styleObj).forEach((key) => {
          let val = styleObj[key];
          if (key === "barColors") {
            if (dsf.isArray(val) && val.length > 0) {
              let arr = _.cloneDeep(this.headData);
              this.styleChangeHeaderAttr(arr, {
                barColors: val,
              });
              this.$emit(`update:headData`, arr);
            }
          } else {
            this.$emit(`update:${key}`, val);
          }
        });
      }
    },
  },
};
